import React from 'react';
import { Box, Skeleton, VStack, ScrollView } from 'native-base';
import { ISkeletonTextProps } from 'native-base/lib/typescript/components/composites';
import { Card, Panel, Section } from '~/shared/Theme';
import { useTheme } from '@springbig/shared';

const RewardsSkeleton = () => {

    const {
        radius_sm,
    } = useTheme();

    const rounded = radius_sm ?? "md";

    const DarkSkeleton = ({ ...props } : ISkeletonTextProps) => {
        return <Skeleton rounded={rounded} startColor={'#c6c6c6'} endColor={'#c6c6c6'} {...props} />;
    };

    return (
        <Section>     
            <ScrollView showsVerticalScrollIndicator={false}>
                <Panel>
                    <VStack alignItems='center' space={'4px'}>
                        <DarkSkeleton w="50px" h="26px" />
                        <DarkSkeleton w="136px" h="26px" />
                        <DarkSkeleton w="80%" h="30px" />
                    </VStack>
                </Panel>
                {[...Array(2)].map((_, index) => (

                    <VStack key={index}>
                        <VStack py={4}>
                            <Box px={4}>
                                <DarkSkeleton w={'70%'} h="30px" />
                            </Box>
                        </VStack>
                        <Panel row  backgroundColor='#f3f3f3'>
                            <ScrollView
                                w={'100%'}
                                horizontal={true}
                                decelerationRate={0}
                                showsHorizontalScrollIndicator={true}
                            >
                                {
                                    [...Array(3)].map((_, index) => {

                                        return (
                                            <Box
                                                key={index}
                                                mr={4}
                                                maxW={160}
                                                alignSelf={'auto'}
                                            >
                                                <DarkSkeleton w={'160px'} h={'224px'} />
                                            </Box>
                                        );
                                    })
                                } 
                            </ScrollView>
                        </Panel>
                    </VStack>
                ))}
            </ScrollView>
        </Section>
    );
};

export default RewardsSkeleton;
